export enum QuestionUIWidgetTypeEnum 
{
    Standard,
    RadioButton,
    Checkbox,
    Select
}